<template>

  <div style="overflow-y: auto;">
        <b-overlay
        :show="show"
        spinner-variant="primary"
        spinner-large
        rounded="sm"
        style="height:200vh"
        variant="dark"
        id="loader"
      >
      <b-container fluid style="padding-top: 100px;text-align:left">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">
                  <b-breadcrumb-item href="#home">
                    <router-link to="/Assamese">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        মূখ্যপৃষ্ঠা
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>Sec 194Q সম্মতি</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>
        <div>
          <b-card no-body>
            <b-tabs card fill>
              <b-tab title=" TAN নম্বৰ আপডেট কৰক " active>

                  <div>

                    <b-row style="padding-top: 0px;">
                          <b-col col cols="5" sm="5" md="2" lg="2" style="padding-top: 7px;">
                                <span style="font-weight:600" >উপভোক্তা নম্বৰ <span class="text-danger">*</span></span>
                          </b-col>
                          <b-col col cols="7" sm="7" md="3" lg="3" style="padding-top: 5px;">
                              <b-form-input type="text" maxlength="12" value="" id="consumerNumber" placeholder="আপোনাৰ উপভোক্তা নম্বৰ প্ৰবিষ্ট কৰক" autocomplete="off" trim required />
                          </b-col>
                          <b-col col cols="5" sm="5" md="2" lg="2" style="padding-top: 5px;" >
                              <img id="captcha" src="#" alt="captcha">
                              <a href="#" @click="generateCaptcha()" ><b-icon icon="arrow-clockwise" font-scale="1.8" style="padding-top:7px"></b-icon></a>
                            
                        </b-col>
                        <b-col col cols="4" sm="4" md="2" lg="2" style="padding-top: 5px;">
                            <b-form-input type="number" id="result" placeholder="উত্তৰ
" style="padding-top: 7px;" />
                        </b-col>
                          <b-col col cols="3" sm="3" md="3" lg="1" style="padding-top: 5px;">
                              <b-button @click="showDetails()" block pill variant="primary" size="md" class="go" style="width:100%">
                                <b-icon  icon="arrow-right-short" animation="" scale="1.8" >  </b-icon>
                              </b-button>
                          </b-col>
                        </b-row>
                  <br>
                <!-- </form> -->

                <div id="UserDetails" class="userDetails marginRight30px">
                  <b-row>
                    <b-col cols=12>
                        <span class="heading">উপভোক্তাৰ বিৱৰণ</span>
                    </b-col>
                  </b-row>
                  <hr/>
                  <br>
                  <!-- <form id="userRegistration"> -->
                    <b-row>
                      <b-col col cols="5" sm="2" md="2" lg="2">
                          <span class="label"> উপভোক্তা নাম : </span>
                      </b-col>
                      <b-col col cols="7" sm="4" md="4" lg="3">
                        <span id="consName" ></span>
                        </b-col>

                      <b-col col cols="5" sm="2" md="2" lg="2" class="marginTop10px">
                        <span class="label">সংযোগৰ ধৰণ :</span>
                      </b-col>
                      <b-col col cols="7" sm="4" md="4" lg="3" class="marginTop10px">
                        <span id="connType" ></span>

                      </b-col>
                    </b-row>
                    <br>
                    <b-row>
                      <b-col col cols="5" sm="2" md="2" lg="2">
                           <span class="label">ম'বাইল নম্বৰ  <span class="text-danger">*</span></span> :
                      </b-col>
                      <b-col col cols="7" sm="4" md="4" lg="3">
                        <!-- <b-form-input type="number"  id="mobNo" placeholder="Not Available" trim>
                        </b-form-input> -->
                        <span id="mobNo" style="display:block;"></span>
                        <span class="updateMobilestyle" style="display: none;"  >ম'বাইল নম্বৰ পঞ্জীভুক্ত নহয়</span>
                        
          <!--
                        <span>
                          <a @click="changeMobileNo()" style="color: #e64a19;cursor:pointer "
                            onmouseover="this.style.textDecoration='underline'; this.style.color='blue';"
                            onmouseout="this.style.textDecoration='none'; this.style.color='#e64a19 ';">
                            Change Mobile No
                          </a>
                        </span> -->
                      </b-col>
                      <b-col col cols="5" sm="2" md="2" lg="2" class="marginTop10px">
                         <span class="label">ইমেইল আইডি </span> :
                      </b-col>
                      <!-- <b-col col cols="7" sm="4" md="4" lg="3" class="marginTop10px">
                        <b-form-input type="email" id="email"  placeholder="Not Available" trim  >
                         </b-form-input> -->
                         <span id="email" style="display: block;"></span>
                         <span class="updateEmailstyle" style="display: none;">উপলব্ধ নহয়</span>
                      </b-col>

                    </b-row>
                    <br>
                    <b-row>
                      <b-col col cols="5" sm="2" md="2" lg="2">
                        <span class="label"> টেন (TAN) নম্বৰ  <span class="text-danger">*</span></span> :
                      </b-col>
                      <b-col col cols="7" sm="4" md="4" lg="3">
                        <b-form-input type="text" maxlength="12" id="tan"  placeholder=" টেন(TAN)  নম্বৰ প্ৰবিষ্ট কৰক" trim  >
                         </b-form-input>
                      </b-col>
                      <b-col col cols="5" sm="2" md="2" lg="2">
                        <span class="label"> পেন(PAN) নম্বৰ  </span> :
                      </b-col>
                      <b-col col cols="7" sm="4" md="4" lg="3">
                        <b-form-input type="text" maxlength="12" id="pan"  placeholder="পেন নম্বৰ প্ৰবিষ্ট কৰক" trim  >
                         </b-form-input>
                      </b-col>

                    </b-row>
                    <br>
                    <b-row>
                      <b-col col cols="12" sm="12" md="12" lg="12">
                        <b-form-checkbox
                           id="checkbox-1"
                           v-model="status1"
                           name="checkbox-1"
                           value="accepted"
                           unchecked-value="not_accepted"
                         >
                         আমি/মই ঘোষণা কৰোঁ যে আয়কৰ আইন, 1961ৰ ধাৰা 194Q আমাৰ/মোৰ বাবে প্ৰযোজ্য আৰু
                         আমি/মই এই শাখাৰ ব্যৱস্থা আৰু সম্পৰ্কিত প্ৰযোজ্য নিয়ম,অধিসূচনা, বিজ্ঞপ্তিবোৰ পঢ়িছোঁ আৰু বুজি পাইছো |
                        </b-form-checkbox>
                        <br>
                        <b-form-checkbox
                           id="checkbox-2"
                           v-model="status2"
                           name="checkbox-2"
                           value="accepted"
                           unchecked-value="not_accepted"
                         >
                         আমি/মই নিশ্চিত কৰো যে আমি/মই এপিডিচিএলৰ পৰ্টেলত মাহিলী ভিত্তিত চালান পৰিশোধৰ বিৱৰণ দাখিল/পূৰণ কৰিম আৰু এপিডিচিএলৰ বিলিং কাৰ্যালয়ত ত্ৰৈমাসিক কৰ কৰ্তন প্ৰমাণপত্ৰ দাখিল কৰিম।
                        </b-form-checkbox>
                      </b-col>
                    </b-row>
                    <br>
                    <b-row>
                      <b-col col cols="12" sm="3" md="3" lg="3" offset-md="4" offset-lg="4">
                          <b-button block squared variant="primary"  id="button"  @click="sendOtp()">
                            Submit</b-button>
                           <br>
                      </b-col>
                      <b-col col cols="12" sm="3" md="3" lg="3" offset-md="2" offset-lg="2" id="ApdclPanBtn" style="display:none">
                          <router-link to="/ApdclPanDetails">
                            <b-button block squared variant="outline-primary"  >
                              এপিডিচিএল আইটিআৰ বিৱৰণ প্ৰিণ্ট কৰক
                            </b-button>
                          </router-link>
                           <br>
                      </b-col>
                    </b-row>
                  <!-- </form> -->

                </div>

                </div>

              </b-tab>
              <b-tab title="TDS আপলোড"  >
                <div>

                  <b-row style="padding-top: 0px;">
                        <b-col col cols="5" sm="5" md="2" lg="2" style="padding-top: 7px;">
                              <span style="font-weight:600" >উপভোক্তা নম্বৰ   <span class="text-danger">*</span></span>
                        </b-col>
                        <b-col col cols="7" sm="7" md="3" lg="3" style="padding-top: 5px;">
                            <b-form-input type="text" maxlength="12" value="" id="consumerNumber2" placeholder="উপভোক্তা নম্বৰ প্ৰবিষ্ট কৰক" autocomplete="off" trim required />
                        </b-col>
                        <b-col col cols="5" sm="5" md="2" lg="2" style="padding-top: 5px;" >
                              <img id="captcha2" src="#" alt="captcha">
                              <a href="#" @click="generateCaptcha()" ><b-icon icon="arrow-clockwise" font-scale="1.8" style="padding-top:7px"></b-icon></a>
                        </b-col>
                        <b-col col cols="4" sm="4" md="2" lg="2" style="padding-top: 5px;">
                            <b-form-input type="number" id="result2" placeholder="উত্তৰ" style="padding-top: 7px;" />
                        </b-col>
                        <b-col col cols="3" sm="3" md="3" lg="1" style="padding-top: 5px;">
                            <b-button @click="showDetails2()" block pill variant="primary" size="md" class="go" style="width:100%">
                              <b-icon  icon="arrow-right-short" animation="" scale="1.8" >  </b-icon>
                            </b-button>
                        </b-col>
                      </b-row>
                <br>
              <!-- </form> -->

              <div id="UserDetails2" class="userDetails marginRight30px" >
                <b-row>
                  <b-col cols=12>
                      <span class="heading">উপভোক্তাৰ বিৱৰণ</span>
                  </b-col>
                </b-row>
                <hr/>
                <br>
                <!-- <form id="userRegistration"> -->
                  <b-row>
                    <b-col col cols="5" sm="2" md="2" lg="2">
                        <span class="label"> উপভোক্তা নাম : </span>
                    </b-col>
                    <b-col col cols="7" sm="4" md="4" lg="3">
                      <span id="consName2" ></span>
                      </b-col>

                    <b-col col cols="5" sm="2" md="2" lg="2" class="marginTop10px">
                      <span class="label">টেন নম্বৰ: </span>
                    </b-col>
                        <b-col col cols="7" sm="4" md="4" lg="3" class="marginTop10px">
                        <span id="tan2" ></span>
                      <br>
                       <span>
                          <a @click="reloadPage()" style="color: #0277bd ;cursor:pointer "
                            onmouseover="this.style.textDecoration='underline'; this.style.color='e64a19';"
                            onmouseout="this.style.textDecoration='none'; this.style.color='#0277bd ';">
                            টেন (TAN) নম্বৰ আপডেট কৰিবলৈ ইয়াত ক্লিক কৰক</a>
                        </span>

                    </b-col>
                  </b-row>
                  <br>

                  <div id="tdsEntry">
                  <b-row>
                    <b-col col cols="5" sm="2" md="2" lg="2">
                         <span class="label">বিল নম্বৰ <span class="text-danger">*</span></span> :
                    </b-col>
                    <b-col col cols="7" sm="4" md="4" lg="3">
                         <b-form-select id="billNo" v-model="billNoSelected" :options="options"></b-form-select>
                      <!--
                      <span>
                        <a @click="changeMobileNo()" style="color: #e64a19;cursor:pointer "
                          onmouseover="this.style.textDecoration='underline'; this.style.color='blue';"
                          onmouseout="this.style.textDecoration='none'; this.style.color='#e64a19 ';">
                          Change Mobile No
                        </a>
                      </span>
                     -->
                    </b-col>
                    <b-col col cols="5" sm="2" md="2" lg="2" class="marginTop10px">
                       <span class="label">টিডিএছ কৰ্তন কৰা হৈছে </span> :
                   </b-col>
                    <b-col col cols="7" sm="4" md="4" lg="3" class="marginTop10px">
                      <b-form-input type="number" id="tdsDeducted"  v-model="TdsAmount"  placeholder="কৰ্তন কৰা টিডিএছ প্ৰবিষ্ট কৰক" @keyup="numToWord()"  >
                       </b-form-input>
                  </b-col>
                  <b-col col cols="12" sm="12" md="1" lg="1"    @click="$bvModal.show('showAmount')">
                    <b-form-checkbox
                       id="checkbox-4"
                       v-model="verify1"
                       name="checkbox-4"
                       value="verified"
                       unchecked-value="not_verified"

                     >
                      Verify
                    </b-form-checkbox>
                  </b-col>
                </b-row>
                <br>
                <b-row>
                  <b-col col cols="5" sm="2" md="2" lg="2" offset-lg="5" class="marginTop10px">
                     <span class="label">শব্দত  </span> :
                 </b-col>
                 <b-col col cols="7" sm="4" md="4" lg="3" class="marginTop10px" style="border-bottom:1px solid black;">
                    <span id="tdsDeductedWord"  style="color:#ff7043;"> </span>

                </b-col>
                <b-col col cols="12" sm="12" md="1" lg="1"   @click="$bvModal.show('showAmount')">
                  <b-form-checkbox
                     id="checkbox-5"
                     v-model="verify2"
                     name="checkbox-5"
                     value="verified"
                     unchecked-value="not_verified"
                   >
                    Verify
                  </b-form-checkbox>
                </b-col>
              </b-row>

                  <br>
                  <b-row>
                    <b-col col cols="5" sm="2" md="2" lg="2">
                      <span class="label">  চালান নম্বৰ <span class="text-danger">*</span></span> :
                    </b-col>
                    <b-col col cols="7" sm="4" md="4" lg="3">
                      <b-form-input type="text" id="challanNo" v-model="challanNo"   placeholder="চালান নম্বৰ প্ৰবিষ্ট কৰক" trim  >
                       </b-form-input>
                    </b-col>
                    <b-col col cols="5" sm="2" md="2" lg="2">
                      <span class="label"> চালান তাৰিখ </span> :
                    </b-col>
                    <b-col col cols="7" sm="4" md="4" lg="3">

                       <b-form-datepicker id="datepicker" v-model="challanDate" class="mb-2"></b-form-datepicker>
                        <!-- <p>Value: '{{ challanDate }}'</p> -->
                    </b-col>

                  </b-row>
                  <br>
                  <b-row>
                    <b-col col cols="5" sm="2" md="2" lg="2">
                      <span class="label">   চালানৰ পৰিমাণ <span class="text-danger">*</span></span> :
                    </b-col>
                    <b-col col cols="7" sm="4" md="4" lg="3">
                      <b-form-input type="number" id="challanAmt" v-model="challanAmt"  placeholder="চালানৰ পৰিমাণ প্ৰবিষ্ট কৰক"   >
                       </b-form-input>
                    </b-col>
                    <b-col col cols="5" sm="2" md="2" lg="2">
                      <span class="label"> চালান আপলোড কৰক </span> :
                    </b-col>
                    <b-col col cols="7" sm="4" md="4" lg="3">
                      <b-form-file  plain id="challanToUpload"></b-form-file>
                      <span id="challanAlreadyUploaded" style="color:#0277bd;display:none"> চালান ইতিমধ্যে এই টেন নম্বৰৰ বাবে আপলোড কৰা হৈছে</span>
                    </b-col>

                  </b-row>
                  <br>
                  <b-row>
                    <b-col col cols="12" sm="12" md="12" lg="12">
                      <b-form-checkbox
                         id="checkbox-3"
                         v-model="status3"
                         name="checkbox-3"
                         value="accepted"
                         unchecked-value="not_accepted"

                       >
                      <div style="text-align:justify">  মই <input type="text" id="authorizedPerson" v-model="authName" placeholder=""
                        style="border: 0;border-bottom: 1px solid black;" class="declaration"> </input>

                         <span class="declaration">{{ consName}} ৰ হৈ অনুমোদিত ব্যক্তিজন</span> উপভোক্তা নম্বৰ 
                        <span class="declaration">{{ consNo}} থকা</span>
                        ইয়াৰ দ্বাৰা গ্ৰহণ কৰিছো আৰু দাখিল কৰিছো যে আয়কৰ আইন, 1961 ধাৰা 194Q-ৰ বিধান অনুসৰি টিডিএছ হিচাপে Rs <span class="declaration">{{ TdsAmount }} ({{ TdsAmountWord }})</span> টকা কৰ্তন কৰা হৈছে বিদ্যুৎ বিলৰ পৰা ভাইড ইনভইচ নম্বৰ <span class="declaration">{{ billNoSelected }} </span> dated <span class="declaration">{{ billDate}} </span>
                        আৰু একেখিনি সংশ্লিষ্ট কৰ্তৃপক্ষক জমা কৰা হৈছিল ভাইড চালান নম্বৰ <span class="declaration">{{ challanNo}} </span> dated
                        <span class="declaration">{{challanDate}}</span>.

                        যদি যিকোনো সময়ত, দেখা যায় যে ওপৰৰ ঘোষণাটো যিকোনো দিশত মিছা,
                        মই <span class="declaration">{{ authName}} </span> লগতে <span class="declaration">{{ consName}} </span> উপভোক্তা নম্বৰ 
                        <span class="declaration">{{ consNo}}থকা </span>
                       দায়বদ্ধ হ'ম আৰু এ.পি.ডি.চি.এল.-য়ে এ.পি.ডি.চি.এল.-ৰ দ্বাৰা উপযুক্ত বুলি গণ্য কৰা পৰিমাণলৈকে যিকোনো আইনী আশ্ৰয় ল'ব পাৰে আৰু সম্পত্তি সংলগ্ন কৰিব পাৰে।

                        মই <span class="declaration">{{ authName}} </span>ৰ হৈ অনুমোদিত ব্যক্তিজন <span class="declaration">{{ consName}} </span>
                        উপভোক্তা নম্বৰ <span class="declaration">{{ consNo}} থকা </span> ইয়াৰ দ্বাৰা এইটোও প্ৰতিশ্ৰুতি দিছো যে মই বা<span class="declaration">{{ consName}} </span> কোনো সময়তে কোনো আদালতত এপিডিচিএলৰ সিদ্ধান্তক প্ৰত্যাহ্বান জনাব নোৱাৰিম
                        মই <span class="declaration">{{ authName}}</span><span class="declaration">{{ consName}}ৰ হৈ অনুমোদিত ব্যক্তিজন </span>
                        উপভোক্তা নম্বৰ  <span class="declaration">{{ consNo}} থকা</span> ইয়াৰ দ্বাৰা এইটোও প্ৰতিশ্ৰুতি দিছো যে যিকোনো আইনী প্ৰক্ৰিয়াত ভাৰতীয় প্ৰমাণ আইন, 1872-ৰ অধীনত এই অনলাইন দাখিলক আইনী প্ৰমাণ হিচাপে গণ্য কৰিব পাৰি।”
                      </div>
                      </b-form-checkbox>

                    </b-col>
                  </b-row>
                  <br>
                  <b-row>
                    <b-col col cols="12" sm="3" md="3" lg="3" offset-md="4" offset-lg="4">
                        <!-- <b-button block squared variant="primary"  id="button"  @click="tdsDetailsUpdate()">
                          Submit</b-button> -->
                          <b-button block squared variant="primary"  id="button"  @click="sendTdsOTP()">
                            Submit</b-button>
                         <br>
                    </b-col>

                  </b-row>
                <!-- </form> -->
              </div>
              </div>

            </div>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>

  </b-container>
  <br>


  <b-modal id="otpModal" centered no-close-on-esc  no-close-on-backdrop title="OTP Verification" hide-footer>
    <b-overlay
    :show="show1"
    spinner-variant="primary"
    spinner-large
    rounded="sm"
    style=""
    variant="dark"
    id="loader"
  >
  আপোনাৰ ম'বাইল নম্বৰত প্ৰাপ্ত অ'টিপি প্ৰবিষ্ট কৰক :
    <b-form-input type="number" id="otp" ></b-form-input><br>
    <b-button class="btn" variant="primary" id="success-btn" @click="tanUpdate()" >Verify</b-button> &nbsp&nbsp
    <b-button class="btn" variant="outline-primary" id="success-btn" @click="resendOtp()" >Resend OTP</b-button>
    </b-overlay>
  </b-modal>

  <b-modal id="otpModalTds" centered no-close-on-esc  no-close-on-backdrop title="OTP Verification" hide-footer>
    <b-overlay
    :show="show1"
    spinner-variant="primary"
    spinner-large
    rounded="sm"
    style=""
    variant="dark"
    id="loader"
  >
  আপোনাৰ ম'বাইল নম্বৰত প্ৰাপ্ত অ'টিপি প্ৰবিষ্ট কৰক  :
    <b-form-input type="number" id="TdsOtp" ></b-form-input><br>
    <b-button class="btn" variant="primary" id="success-btn" @click="tdsDetailsUpdate()" >Verify</b-button> &nbsp&nbsp
    <b-button class="btn" variant="outline-primary" id="success-btn" @click="resendOtpTds()" >Resend OTP</b-button>
    </b-overlay>
  </b-modal>


<b-modal id="showAmount" centered no-close-on-esc no-close-on-backdrop scrollable  hide-footer hide-header lazy>
  <h3>আপুনি প্ৰবিষ্ট  কৰিছে </h3>
  <br>
   Amount:  <span style="color:#ff5722;font-weight:600">
    Rs. {{ TdsAmount }}
  </span>
  <br>
    In Words: <span style="color:#ff5722;font-weight:600 "> {{ TdsAmountWord }}</span>
      <br>
<br>
<p>
    <b-button class="btn btn-outline" variant="primary" @click="closeModal('showAmount')">Confirm</b-button>
      <!-- <b-button class="btn btn-outline" variant="danger" @click="closeModal('showAmount')">Edit</b-button> -->
  </p>
</b-modal>


  <b-modal id="successModal" centered no-close-on-esc no-close-on-backdrop scrollable  hide-footer hide-header>
    <h3>উপভোক্তা টেন নম্বৰ আপডেট</h3>
    <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
      <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
      <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
    </svg>
    <p class="success">সফলতাৰে আপডেট কৰা হৈছে !<br><br>
      <router-link to="/ApdclPanDetails">
          <b-button class="btn btn-outline" variant="success">OK</b-button>
      </router-link>

    </p>
  </b-modal>
  <b-modal id="successModal2" centered no-close-on-esc no-close-on-backdrop scrollable  hide-footer hide-header>
    <h3>TDS আপলোড</h3>
    <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
      <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
      <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
    </svg>
    <p class="success">সফলতাৰে আপডেট কৰা হৈছে!<br><br>

          <b-button class="btn btn-outline" variant="success" @click="reloadPage()">OK</b-button>


    </p>
  </b-modal>

  <b-modal id="failureModal" centered lazy scrollable title="উপভোক্তা টেন নম্বৰ আপডেট" hide-footer>
    <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
      <circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
      <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3"/>
      <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2"/>
    </svg>
    <p class="error">আপডেইট ব্যৰ্থ ! </p>
  </b-modal>
  <b-modal id="failureModal2" centered lazy scrollable title="TDS Upload" hide-footer>
    <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
      <circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
      <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3"/>
      <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2"/>
    </svg>
    <p class="error">আপডেইট ব্যৰ্থ বা TDS ইতিমধ্যে আপলোড কৰা হৈছে </p>
  </b-modal>

  <b-modal id="model" centered  scrollable title="ALERT !" :static="true" hide-footer>
    <span class="data" id="modalMsg">  </span>
    <br><br>
      <b-button  style="width:8rem" variant="outline-primary" @click="closeModal('model')">OK</b-button>
  </b-modal>
</b-overlay>
  </div>

</template>


<script>
import axios from 'axios';
import HeaderFixed from '@/components/AS_HeaderFixed.vue'
import HeaderMobile from '@/components/AS_HeaderMobile.vue'
const numWords = require('num-words');

var consNo= "";
var oldMob="";
var email ="";
var tan ="";
var pan="";
var dataToSend;

export default {
  name: 'ConsReg',
  components: {

    'HeaderFixed' : HeaderFixed,
    'HeaderMobile' : HeaderMobile
    //MarqueeText

  },
  computed: {

  },
  data() {
    return {
        value: '',
        show: false,
        show1: false,
        show2 : false,
        consNumber: "",
        status1: 'not_accepted',
        status2: 'not_accepted',
        status3: 'not_accepted',
        verify1: 'not_verified',
        verify2: 'not_verified',
        billNoSelected: null,
        options: [

       ],
      TdsAmount:'',
      TdsAmountWord:'',
      consName:'',
      consNo:'',
      billNo:'',
      billDate:'',
      challanNo:'',
      challanDate:'',
      challanAmt:'',
      authName:'',
      tanNo:'',


    }
  },
  methods: {
    reloadPage()
    {
      window.location.reload();
    },
    generateCaptcha()
    {
      axios.post(this.$urlCommon+"/api/web/getCaptcha").then(function(response) {
                //console.log(response.data);
                document.getElementById("captcha").src= "data:image/png;base64,"+response.data;
                document.getElementById("captcha2").src= "data:image/png;base64,"+response.data;


    })
    },
    
    showDetails() {
      consNo= document.getElementById("consumerNumber").value;
      this.consNumber=consNo;
      var result = document.getElementById("result").value;

        if ((consNo.toString().length!=12))
           {
             this.$bvToast.toast('১২ টা অংকৰ উপভোক্তা নম্বৰ প্ৰবিষ্ট কৰক !', {
               title: `Alert`,
               variant: 'danger',
               solid: true
             })
             document.getElementById("consumerNumber").focus();
             return;
           }
     
      if ((result==""))
           {
             this.$bvToast.toast('Captcha উত্তৰ প্ৰবিষ্ট কৰক!', {
               title: `Alert`,
               variant: 'danger',
               solid: true
             })
             return;
           }
      var parent=this;
      this.show= true;
    // axios.post(this.$urlArms+'/RestAPI/myBijulee/ConsDetails?cons_no='+consNo)
     axios.get(this.$urlCommon+'/api/web/updateTanNo/getConsDetails?consNo='+consNo+"&result="+result)
        .then((response) => {
        parent.show= false;
        document.getElementById("UserDetails").classList.add("showUserDetails");

        console.log(response.data);
        var data=response.data;
        var status = data.message;


        if(status=="00")
        {
          parent.generateCaptcha();
          document.getElementById("consName").innerHTML = data.cons_name;
          document.getElementById("connType").innerHTML = data.connType;
          document.getElementById("mobNo").innerHTML = data.mobile_no;
          oldMob = data.mobile_no;
          console.log("data.mobile_data::::::::"+oldMob);
          if (data.mobile_no === "") {
                document.querySelector(".updateMobilestyle").style.display = 'block';
            } else {
                document.querySelector(".updateMobilestyle").style.display = 'none';
            }
          email = data.email
          if (email === "") {
              let element = document.querySelector(".updateEmailstyle");
              if (element) {
                  element.style.display = 'block';
              } else {
                  console.error("Element with class 'updateEmailstyle' not found");
              }
          } else {
              let element = document.querySelector(".updateEmailstyle");
              if (element) {
                  element.style.display = 'none';
                  document.getElementById("email").style.display = 'block';
              } else {
                  console.error("Element with class 'updateEmailstyle' not found");
              }
          }
          document.getElementById("email").value = data.email;
          document.getElementById("tan").value = data.tan_NO;
          document.getElementById("pan").value = data.pan_NO;
          console.log(data.tan_NO.length);
          if(data.tan_NO.length>0)
              document.getElementById("ApdclPanBtn").style.display="block";

        }
        else if(status=="captcha_incorrect"){
              parent.$bvToast.toast('অবৈধ কেপচা! অনুগ্ৰহ কৰি পুনৰ চেষ্টা কৰক', {
                   title: `Alert`,
                   variant: 'danger',
                   solid: true
                 });
              document.getElementById("UserDetails").classList.remove("showUserDetails");
              parent.generateCaptcha();
            }
        else
        {
          parent.show= false;
          parent.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML="ক্ষমা কৰিব, উপভোক্তা পোৱা নগ'ল  ";
          document.getElementById("UserDetails").classList.remove("showUserDetails");
        }

      })
      .catch((e) => {
      console.log("Caught", e);
      this.show= false;
    })

  },
  showDetails2() {
    consNo= document.getElementById("consumerNumber2").value;
    this.consNumber=consNo;
    
       if ((consNo.toString().length!=12))
           {
             this.$bvToast.toast('১২ টা অংকৰ উপভোক্তা নম্বৰ প্ৰবিষ্ট কৰক !', {
               title: `Alert`,
               variant: 'danger',
               solid: true
             })
             return;
           }
      var result = document.getElementById("result2").value;
      if ((result==""))
           {
             this.$bvToast.toast('Captcha প্ৰবিষ্ট কৰক !!', {
               title: `Alert`,
               variant: 'danger',
               solid: true
             })
             return;
           }
            var parent=this;
            this.show= true;
          //axios.get(this.$urlArms+'/RestAPI/OnlinePortal/tdsConsDetails?consNo='+consNo)
          axios.get(this.$urlCommon+'/api/web/TdsUpload/getConsDetails?consNo='+consNo+"&result="+result)
              .then((response) => {
                parent.show= false;
    
      if(response.data.status=="success"){
             
        document.getElementById("UserDetails2").classList.add("showUserDetails");
        console.log(response.data);
        var data=response.data;
        var status = data.message;
        this.options=[];
          document.getElementById("consName2").innerHTML = data.consName;
          document.getElementById("tan2").innerHTML = data.tanNo;
          parent.consName = data.consName;
          parent.consNo = data.consNo;
          parent.tanNo=data.tanNo;

          if(data.tanNo=="")
          {
              document.getElementById("tan2").innerHTML = "TAN নম্বৰ উপলব্ধ নহয়";
              document.getElementById("tan2").style.color = "red";
              document.getElementById("tdsEntry").style.display = "none";
              return;
          }

        var obj0={ value: null, text: 'Please Select Bill No' }
        this.options.push(obj0);

        console.log(data.billList.length);
        if(data.billList.length==2)
        {
          parent.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML="ক্ষমা কৰিব, বিল পোৱা নগ'ল";
          document.getElementById("UserDetails2").classList.remove("showUserDetails");
          return;
        }

        if(data.billList.length==11)
        {
          var res0 = data.billList.substring(1, 10);
          console.log(res0);
          var obj1 = {value:res0, text:res0 };
          this.options.push(obj1);
        }
        if(data.billList.length==22)
        {
          var res = data.billList.split(",")
          var res0 = res[0].substring(1);
          var obj1 = {value:res0, text:res0 };
          this.options.push(obj1);
        var res1 = res[1].substring(1);
        var res2 = res1.substring(0, res1.length - 1);
        var obj2 = {value:res2, text:res2 };
        this.options.push(obj2);
        }
        }
      
      else if(response.data.message=="captcha_incorrect"){
              parent.$bvToast.toast('Invalid Captcha ! Please try again', {
                   title: `Alert`,
                   variant: 'danger',
                   solid: true
                 });
              document.getElementById("UserDetails2").classList.remove("showUserDetails");
              parent.generateCaptcha();
            }
       else
      {
        parent.$bvModal.show('model');
        document.getElementById("modalMsg").innerHTML="উপভোক্তা পোৱা নগ'ল ";
        document.getElementById("UserDetails2").classList.remove("showUserDetails");
      }
      

     // var parent2 = parent;

        //axios.post("http://localhost:8081/website/api/web/checkFileUpload?tanNo="+data.tanNo)
    /*axios.post(parent.$urlCommon+"/api/web/checkFileUpload?tanNo="+data.tanNo)
         .then((response) => {
           parent2.show= false;
           console.log(response.data.count);
           if(response.data.count!=0)
           {
               document.getElementById("challanToUpload").style.display = "none";
               document.getElementById("challanAlreadyUploaded").style.display = "block";
           }
         })
         */



    })
    .catch((e) => {
    console.log("Caught", e);
    parent.$bvModal.show('model');
    document.getElementById("modalMsg").innerHTML="ক্ষমা কৰিব, উপভোক্তা /বিল পোৱা নগ'ল";
    document.getElementById("UserDetails2").classList.remove("showUserDetails");
    this.show= false;
  })

},
changeMobileNo()
{
    document.getElementById("mobNo").value="";
    document.getElementById("mobNo").focus();
},
sendOtp()
{
  var parent =this;
  var mobile = document.getElementById("mobNo").innerHTML;
  // console.log("Sendotp mobile:::::"+mobile);
  email = document.getElementById("email").value;
  tan = document.getElementById("tan").value;
  pan = document.getElementById("pan").value;
  var consNo = document.getElementById("consumerNumber").value;
  // console.log("send otp cons no::::::"+consNo)
  // console.log(tan+"#####"+pan);
  
  var mobregx = /^[5-9]\d{9}$/
  if(mobile== ' ')
    {
      this.$bvToast.toast('আপোনাৰ একাউণ্ট কোনো মবাইল নম্বৰৰ সৈতে লিংক কৰা নাই। অনুগ্ৰহ কৰি আপোনাৰ মবাইল নম্বৰ আপডেট কৰিবলৈ আপোনাৰ উপ-বিভাগ কাৰ্যালয়লৈ যাওঁক।', {
        title: `Alert`,
        variant: 'danger',
        solid: true
      })
      document.getElementById("mobNo").focus();
    return
    }
  // else if(!mobregx.test(mobile))
  //   {
     
  //     this.$bvToast.toast('Registered Mobile Number is not a 10 Digit Valid Mobile Number !', {
  //       title: `Alert`,
  //       variant: 'danger',
  //       solid: true
  //     })
  //     document.getElementById("mobNo").focus();
  //   return
  //   }

    // var emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    // if(!emailRegex.test(email) && email!="")
    //   {
    //     // document.getElementById('failure-btn-mob').click();
    //     this.$bvToast.toast('Enter Valid Email !', {
    //       title: `Alert`,
    //       variant: 'danger',
    //       solid: true
    //     })
    //     document.getElementById("email").focus();
    //   return
    //   }

      var tanRegex = /^([a-zA-Z]){4}([0-9]){5}([a-zA-Z]){1}?$/;
      if(!tanRegex.test(tan) && tan!="UPDATED")
        {
          // document.getElementById('failure-btn-mob').click();
          this.$bvToast.toast('বৈধ টেন নম্বৰ প্ৰবিষ্ট কৰক!!', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          })
          document.getElementById("tan").focus();
        return
        }


      var panRegex =  /(^([a-zA-Z]{5})([0-9]{4})([a-zA-Z]{1})$)/;
      if(!panRegex.test(pan) && pan!="" && pan!="UPDATED")
        {
          // document.getElementById('failure-btn-mob').click();
          this.$bvToast.toast('বৈধ পেন নম্বৰ প্ৰবিষ্ট কৰক  !', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          })
          document.getElementById("pan").focus();
        return
        }
        if(this.status1=== "not_accepted" )
          {
            // document.getElementById('failure-btn-mob').click();
            this.$bvToast.toast('অনুগ্ৰহ কৰি ঘোষণা গ্ৰহণ কৰক   !', {
              title: `Alert`,
              variant: 'danger',
              solid: true
            })
            document.getElementById("checkbox-1").focus();
          return
          }
          if(this.status2=== "not_accepted" )
            {
              // document.getElementById('failure-btn-mob').click();
              this.$bvToast.toast('অনুগ্ৰহ কৰি ঘোষণা গ্ৰহণ কৰক  !', {
                title: `Alert`,
                variant: 'danger',
                solid: true
              })
              document.getElementById("checkbox-2").focus();
            return
            }
    dataToSend={
      cons_no:consNo,
      tan_no:tan,
      pan_no:pan,
      declaration_1:this.status1,
      declaration_2:this.status2
      }
    // console.log("data to send:::::"+JSON.stringify(dataToSend));


 parent.show= true;
  // axios.post(parent.$urlCommon+"/api/generateOtp?mobNo="+mobile).then(function(response) {
  axios.post(parent.$urlCommon+"/api/otp/sendConsumerOTP?consNo="+consNo).then(function(response) {
    // console.log("OTP response::::"+JSON.stringify(response.data));
    parent.show= false;
    if (response.data.msg == "success") {
      parent.$bvToast.toast('ওটিপি সফলতাৰে প্ৰেৰণ কৰা হৈছে !', {
        title: `Success`,
        variant: 'success',
        solid: true
      });
      parent.$bvModal.show('otpModal');
    }
  });

},

closeModal(modalId){
  this.$bvModal.hide(modalId)
},
resendOtp()
{
  var parent =this;
  // var mobile = document.getElementById("mobNo").value;
  var consNo = document.getElementById("consNo").value;
  parent.show1= true;
  // axios.post(this.$urlCommon+"/api/reGenerateOtp?mobNo="+mobile).then(function(response) {
    axios.post(this.$urlCommon+"/api/otp/SendConsumerOTP?consNo="+consNo+"&type=resend").then(function(response) {
    parent.show1= false;
    if (response.data.message == "success") {
      parent.$bvToast.toast('ওটিপি সফলতাৰে প্ৰেৰণ কৰা হৈছে !', {
        title: `Success`,
        variant: 'success',
        solid: true
      });
    }
  else {
      parent.$bvToast.toast('ওটিপি  প্ৰেৰণ কৰিব পৰা নগল !', {
        title: `danger`,
        variant: 'danger',
        solid: true
      });
    }
  });
},

tanUpdate(){
      var otp = document.getElementById("otp").value;
      // var mobile = document.getElementById("mobNo").value;
      var parent=this;

      // var mobregx = /^[5-9]\d{9}$/
      // if(!mobregx.test(mobile))
      // {

      //   this.$bvToast.toast('Enter 10 Digit Valid Mobile Number !', {
      //     title: `Alert`,
      //     variant: 'danger',
      //     solid: true
      //   })
      // return;
      // }


     if(otp=="")
        {

          this.$bvToast.toast('ওটিপি প্ৰবিষ্ট কৰক !', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          })
        return;
        }

      parent.show1= true;
      // axios.post(parent.$urlCommon+"/api/validateOtp?mobNo="+mobile+"&otpNo="+otp).then(function(response)
      // {
      //   console.log(response.data);

      //   if (response.data.message == "VALID") {

      //       parent.$bvToast.toast('OTP Successfully Verified !', {
      //       title: `Success`,
      //       variant: 'success',
      //       solid: true
      //     });

//          axios.post(parent.$urlCommon+"/myBijulee/updateTanDetails?mobNo="+mobile+"&email="+email,dataToSend).then(function(response) {
          // axios.post(parent.$urlCommon+"/myBijulee/updateTanDetails?mobNo="+mobile+"&email="+email+"&otpNo="+otp,dataToSend).then(function(response) {
          axios.post(parent.$urlCommon+"/api/web/updateTanNo/update?otpNo="+otp,dataToSend).then(function(response) {
          console.log(JSON.stringify(response.data));
          parent.show1= false;
          parent.show= false;
          var msg=response.data.msg;
          if(msg=="00") {

            parent.$bvModal.show('successModal');
          }
          else
          {

            parent.$bvModal.show('failureModal');
          }
          })
          .catch((e) => {
            parent.show= false;
            parent.$bvModal.show('model');
            document.getElementById("modalMsg").innerHTML="ক্ষমা কৰিব, পিছত আকৌ চেষ্টা কৰক";
            console.log("Caught :::::::::::::::", e.message);
          })
        // }
        // else{
        //   parent.show1= false;
        //   parent.$bvModal.show('model');
        //   document.getElementById("modalMsg").innerHTML="Invalid OTP";
        // }

     // });

    },

    numToWord()
    {

      var num=   document.getElementById("tdsDeducted").value;
      const amountInWords = numWords(num);
      document.getElementById("tdsDeductedWord").innerHTML=amountInWords;
    //  document.getElementById("TdsAmountWordHidden").value=amountInWords;
      this.TdsAmountWord=amountInWords;
    //  console.log("Amt:"+amountInWords);
    },

    sendTdsOTP(){

      var parent=this;

        if(this.billNoSelected==null)
          {
            this.$bvToast.toast('এটা বিল নম্বৰ নিৰ্বাচন কৰক !', {
            title: `Error`,
            variant: 'danger',
            solid: true
          });
          document.getElementById("billNo").focus();
          return;
          }

        if(this.TdsAmount=='')
          {
            this.$bvToast.toast('TDS কৰ্তন কৰা ধনৰাশি প্ৰৱেশ কৰক  !', {
            title: `Error`,
            variant: 'danger',
            solid: true
          });
          document.getElementById("tdsDeducted").focus();
          return;
          }
          if(this.verify1=='not_verified')
            {
              this.$bvToast.toast('অনুগ্ৰহ কৰি প্ৰৱেশ কৰা ধনৰাশি পৰীক্ষা কৰক !', {
              title: `Error`,
              variant: 'danger',
              solid: true
            });
            document.getElementById("checkbox-4").focus();
            return;
            }
          if(this.verify2=='not_verified')
              {
                this.$bvToast.toast('অনুগ্ৰহ কৰি প্ৰৱেশ কৰা ধনৰাশি পৰীক্ষা কৰক !', {
                title: `Error`,
                variant: 'danger',
                solid: true
              });
              document.getElementById("checkbox-5").focus();
              return;
              }
           if(this.challanNo=='')
                {
                  this.$bvToast.toast('অনুগ্ৰহ কৰি চালান নম্বৰ প্ৰবিষ্ট কৰক!', {
                  title: `Error`,
                  variant: 'danger',
                  solid: true
                });
                document.getElementById("challanNo").focus();
                return;
                }
          if(this.challanDate=='')
                  {
                    this.$bvToast.toast('অনুগ্ৰহ কৰি চালান তাৰিখ প্ৰবিষ্ট কৰক!', {
                    title: `Error`,
                    variant: 'danger',
                    solid: true
                  });
                  document.getElementById("challanDate").focus();
                  return;
                  }
            if(this.challanAmt=='')
                    {
                      this.$bvToast.toast('অনুগ্ৰহ কৰি চালানৰ পৰিমাণ প্ৰবিষ্ট কৰক !', {
                      title: `Error`,
                      variant: 'danger',
                      solid: true
                    });
                    document.getElementById("challanAmt").focus();
                    return;
                    }

    if(this.authName=='')
        {
          this.$bvToast.toast('অনুগ্ৰহ কৰি অনুমোদিত ব্যক্তিৰ নাম প্ৰবিষ্ট কৰক  !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("authorizedPerson").focus();
        return;
        }
        if(this.status3=='not_accepted')
            {
              this.$bvToast.toast('অনুগ্ৰহ কৰি ঘোষণা পৰীক্ষা কৰক !', {
              title: `Error`,
              variant: 'danger',
              solid: true
            });
            document.getElementById("checkbox-3").focus();
            return;
            }

      var consNo = document.getElementById("consumerNumber2").value;
      console.log("cons:::::"+consNo);

      parent.show = true;

      axios.post(parent.$urlCommon+"/api/otp/sendConsumerOTP?consNo="+consNo).then(function(response) {
        // console.log("OTP response::::"+JSON.stringify(response.data));
        parent.show= false;
        if (response.data.msg == "success") {
          parent.$bvToast.toast('ওটিপি সফলতাৰে প্ৰেৰণ কৰা হৈছে !', {
            title: `Success`,
            variant: 'success',
            solid: true
          });
          parent.$bvModal.show('otpModalTds');
        }
        else {
          parent.$bvToast.toast('ওটিপি প্ৰেৰণ কৰিব পৰা নগল !', {
            title: `danger`,
            variant: 'danger',
            solid: true
          });

        }
      });
      
    },

    resendOtpTds()
    {
      var parent =this;
      // var mobile = document.getElementById("mobNo").value;
      var consNo = document.getElementById("consNo").value;
      parent.show1= true;
      // axios.post(this.$urlCommon+"/api/reGenerateOtp?mobNo="+mobile).then(function(response) {
        axios.post(this.$urlCommon+"/api/otp/SendConsumerOTP?consNo="+consNo+"&type=resend").then(function(response) {
        parent.show1= false;
        if (response.data.message == "success") {
          parent.$bvToast.toast('ওটিপি সফলতাৰে প্ৰেৰণ কৰা হৈছে!', {
            title: `Success`,
            variant: 'success',
            solid: true
          });
        }
      else {
          parent.$bvToast.toast('ওটিপি প্ৰেৰণ কৰিব পৰা নগল  !', {
            title: `danger`,
            variant: 'danger',
            solid: true
          });
        }
      });
    },

    tdsDetailsUpdate(){
      
      var parent=this;
      var otp = document.getElementById("TdsOtp").value;

        var consNo=document.getElementById("consumerNumber2").value;
        var cKey = {};
        cKey['cons_no'] =document.getElementById("consumerNumber2").value;
       	cKey['bill_no'] = this.billNoSelected;

        var tdsDataToSend={
          tdsDetailsDatamodelCompositeId : cKey,
          tan_no: this.tanNo,
          tds_deducted:this.TdsAmount,
          challan_no:this.challanNo,
          challan_date:this.challanDate,
          challan_amt:this.challanAmt,
          tds_verification: this.verify1,
          file_uploaded:'Y',
          declaration:this.status3

          }

          console.log(tdsDataToSend);

            var  formData = new FormData();
            var file = document.querySelector('#challanToUpload');
           
            var fileExt = file.files[0].name.split('.').pop();
            console.log("file  "+fileExt);
            if(fileExt != "pdf"){
                this.$bvToast.toast('কেৱল PDF ফাইলৰ অনুমতি দিয়া হৈছে !', {
                title: `Error`,
                variant: 'danger',
                solid: true
              });
              document.getElementById("challanToUpload").focus();
              return;
            }
              //formData.append("uploadfile", "/path/dd");
            //  formData.append("uploadfile", file.files[0]);
              formData.append("uploadfile", file.files[0]);

              if(otp=="")
              {

                this.$bvToast.toast('ওটিপি প্ৰবিষ্ট কৰক !', {
                  title: `Alert`,
                  variant: 'danger',
                  solid: true
                })
              return;
              }

              parent.show= true;
              // axios.post(parent.$urlArms+"/RestAPI/OnlinePortal/updateTdsConsDetails?consNo="+consNo+"&tanNo="+tdsDataToSend.tan_no+"&billNo="+this.billNoSelected+"&tdsAmountDeducted="+tdsDataToSend.tds_deducted+"&challanNo="+tdsDataToSend.challan_no+"&challanDt="+tdsDataToSend.challan_date+"&challanAmt="+tdsDataToSend.challan_amt+"&authorisedPerson="+this.authName,formData,{
              //     headers: {
              //       'Content-Type': 'multipart/form-data'
              //     }
              // }).then(function(response) {
              axios.post(parent.$urlCommon+"/api/web/updateTdsDetails?otpNo="+otp,tdsDataToSend).then(function(response) {

              console.log(response.data);

             

              var msg=response.data.msg;

              if(msg=="00") {

                axios.post(parent.$urlArms+"/RestAPI/OnlinePortal/updateTdsConsDetails?consNo="+consNo+"&tanNo="+tdsDataToSend.tan_no+"&billNo="+parent.billNoSelected+"&tdsAmountDeducted="+tdsDataToSend.tds_deducted+"&challanNo="+tdsDataToSend.challan_no+"&challanDt="+tdsDataToSend.challan_date+"&challanAmt="+tdsDataToSend.challan_amt+"&authorisedPerson="+parent.authName,formData,{
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                }).then(function(response) {
                  parent.show= false;
               //   parent.show1= false;
                  var msg=response.data.status;
                  if(msg=="Success") {
                    parent.$bvModal.show('successModal2');
                  }
                      else
                  {
                    parent.show= false;
                    parent.$bvModal.show('failureModal2');
                  }
                  }).catch((e) => {
                  parent.show= false;
                  parent.$bvModal.show('model');
                  document.getElementById("modalMsg").innerHTML="ক্ষমা কৰিব, পিছত আকৌ চেষ্টা কৰক";
                  console.log("Caught :::::::::::::::", e.message);
                })
              }
                else
                {
                  parent.$bvModal.show('failureModal2');
                }
              })
              .catch((e) => {
                parent.show= false;
                parent.$bvModal.show('model');
                document.getElementById("modalMsg").innerHTML="ক্ষমা কৰিব, পিছত আকৌ চেষ্টা কৰক";
                console.log("Caught :::::::::::::::", e.message);
              })
            }
  },
  mounted()
  {
    axios.post(this.$urlCommon+"/api/web/getCaptcha").then(function(response) {
                //console.log(response.data);
                document.getElementById("captcha").src= "data:image/png;base64,"+response.data;
                document.getElementById("captcha2").src= "data:image/png;base64,"+response.data;

    })

    document.getElementById('mobNo').addEventListener('keydown', function(event) {
          event.preventDefault();
        });

    document.getElementById('mobNo').readOnly = true;

    document.getElementById('email').addEventListener('keydown', function(event) {
          event.preventDefault();
        });
        
        document.getElementById('email').readOnly = true;

  }
}
</script>

<style scoped="true">
.label{
font-weight: 600;
}
.data{
  font-weight: 500;
  color: #bf360c;
  font-size: 1.1rem;
}
.declaration
{
  color:#263238;
  font-weight:600;
}
.userDetails
{
 visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;
}
.showUserDetails
{
 visibility: visible;
 opacity: 1;
}
.updateMobilestyle{
  padding: 5px; 
  border-radius: 5px; 
  color: red;
  font-weight: bold; 
  background-color: orange;
  animation: flicker 2s infinite;
}
@keyframes flicker {
            0%, 50%, 100% {
                opacity: 1;
            }
            25%, 75% {
                opacity: 0.6;
            }
        }
.updateEmailstyle{
  padding: 5px; 
  border-radius: 5px; 
  margin-left: 10px;
  color: orange;
  font-weight: bold; 
}
hr {
   margin-top: 5px;
   margin-bottom: 5px;
  }
.go:focus{
  box-shadow: none;
}
.modalFont{
  width: 100px;
  display: block;
  margin: 40px auto 0;
}

.path {
  stroke-dasharray: 1000;
  stroke-dashoffset: 0;
}
.path.circle {
  -webkit-animation: dash 0.9s ease-in-out;
  animation: dash 0.9s ease-in-out;
}
.path.line {
  stroke-dashoffset: 1000;
  -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
  animation: dash 0.9s 0.35s ease-in-out forwards;
}
.path.check {
  stroke-dashoffset: -100;
  -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
  animation: dash-check 0.9s 0.35s ease-in-out forwards;
}

p {
  text-align: center;
  margin: 20px 0 60px;
  font-size: 1.25em;
}
p.success {
  color: #73AF55;
}
p.error {
  color: #D06079;
}
.hideDiv
{
  visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;

    padding: 0rem;
}
.showDiv
{
 visibility: visible;
 opacity: 1;
}
@-webkit-keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@-webkit-keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}
@keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}
.headerF{
  display: block;
}
.headerM{
  display: none;
}

@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
  }
  @media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .marginRight30px{
      margin-right: 30px !important;
    }
  }
  @media (max-width: 576px) {
    .marginTop10px{
      margin-top: 10px !important;
    }
  }

</style>
